import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusIntegracaoOrquestrador',
})
export class StatusIntegracaoOrquestradorPipe implements PipeTransform {
  transform(value: number): unknown {
    const status: { [key: number]: string } = {
      0: 'Falha na comunicação',
      1: 'Crítica na integração',
      2: 'Aguardando processamento',
      3: 'Integrado com sucesso',
      9: 'Movimentação recusada',
    };
    return status[value] || status[0];
  }
}
